import { sanitizeHtml } from '../../utils/safeHtml';
import React from 'react';
import './RadiologyTemplatePreviewModal.css';

export default function RadiologyTemplatePreviewModal({
  template,
  investigationName,
  departmentName,
  onClose
}) {
  if (!template) return null;

  const rawHtml = template.templateDesc || template.content || '';

  // Substitute dynamic field tokens with sample clinical data
  const samplePatient = {
    PATIENT_NAME: 'Mr. Rajesh Kumar',
    PATIENT_ID: 'P-2026-8941',
    AGE: '45 Y',
    SEX: 'Male',
    DOB: '14 May 1981',
    STUDY_DATE: new Date().toLocaleDateString('en-GB'),
    REPORT_DATE: new Date().toLocaleDateString('en-GB'),
    ACCESSION_NUMBER: 'ACC-948123',
    REFERRING_DOCTOR: 'Dr. Anil Sharma, MD (Internal Medicine)',
    RADIOLOGIST_NAME: 'Dr. S. K. Rao, MD, DNB (Radiodiagnosis)'
  };

  let renderedHtml = rawHtml;
  Object.keys(samplePatient).forEach((key) => {
    const regex = new RegExp(`{{${key}}}`, 'g');
    renderedHtml = renderedHtml.replace(
      regex,
      `<span class="rad-prev-token-resolved">${samplePatient[key]}</span>`
    );
  });

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="rad-prev-backdrop" onClick={onClose}>
      <div className="rad-prev-modal" onClick={(e) => e.stopPropagation()}>
        {/* Top Control Bar */}
        <div className="rad-prev-topbar">
          <div className="rad-prev-topbar-info">
            <span className="rad-prev-badge">REPORT SIMULATION</span>
            <h3>{template.title || template.templateTitle}</h3>
            <span className="rad-prev-inv">{investigationName || 'Investigation'}</span>
          </div>

          <div className="rad-prev-topbar-actions">
            <button type="button" className="rad-prev-btn print" onClick={handlePrint}>
              🖨️ Print Preview
            </button>
            <button type="button" className="rad-prev-btn close" onClick={onClose}>
              ✕ Close
            </button>
          </div>
        </div>

        {/* The Simulated Clinical Page (A4 Paper Aesthetic) */}
        <div className="rad-prev-page-wrapper">
          <div className="rad-simulated-a4-sheet">
            {/* Hospital Header Banner */}
            <div className="rad-sim-hospital-header">
              <div className="rad-sim-hospital-brand">
                <div className="rad-sim-cross">✚</div>
                <div>
                  <h1 className="rad-sim-hosp-name">APEX DIAGNOSTIC & IMAGING CENTRE</h1>
                  <p className="rad-sim-hosp-addr">
                    Department of Radiodiagnosis & Interventional Radiology • NABL & NABH Accredited
                  </p>
                </div>
              </div>
              <div className="rad-sim-hosp-meta">
                <span>Tel: +91 22 2548 9900</span>
                <span>Email: radiology@apexdiagnostics.org</span>
              </div>
            </div>

            <div className="rad-sim-divider"></div>

            {/* Patient Demographics Table */}
            <div className="rad-sim-demographics-grid">
              <div className="rad-sim-demo-row">
                <span className="lbl">Patient Name:</span>
                <span className="val"><strong>{samplePatient.PATIENT_NAME}</strong></span>
                <span className="lbl">Patient ID (UHID):</span>
                <span className="val">{samplePatient.PATIENT_ID}</span>
              </div>
              <div className="rad-sim-demo-row">
                <span className="lbl">Age / Gender:</span>
                <span className="val">{samplePatient.AGE} / {samplePatient.SEX}</span>
                <span className="lbl">Accession No:</span>
                <span className="val">{samplePatient.ACCESSION_NUMBER}</span>
              </div>
              <div className="rad-sim-demo-row">
                <span className="lbl">Referred By:</span>
                <span className="val">{samplePatient.REFERRING_DOCTOR}</span>
                <span className="lbl">Study Date:</span>
                <span className="val">{samplePatient.STUDY_DATE}</span>
              </div>
              <div className="rad-sim-demo-row highlight">
                <span className="lbl">Investigation:</span>
                <span className="val full-investigation">
                  <strong>{investigationName}</strong> ({departmentName || 'Radiology'})
                </span>
                <span className="lbl">Status:</span>
                <span className="val">CONFIRMED REPORT</span>
              </div>
            </div>

            <div className="rad-sim-divider thick"></div>

            {/* Diagnostic Report Content Body */}
            <div
              className="rad-sim-report-body"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(renderedHtml) }}
            />

            {/* Radiologist Signoff Block */}
            <div className="rad-sim-signature-block">
              <div className="rad-sim-sig-line"></div>
              <p className="rad-sim-dr-name">{samplePatient.RADIOLOGIST_NAME}</p>
              <p className="rad-sim-dr-sub">Consultant Radiologist & Imaging Specialist</p>
              <p className="rad-sim-dr-reg">Medical Reg. No: MMC-2014-9923</p>
              <p className="rad-sim-sign-time">
                Electronically Verified & Signed: {samplePatient.REPORT_DATE}
              </p>
            </div>

            {/* Footer Disclaimer */}
            <div className="rad-sim-footer">
              <small>
                This is a computer generated diagnostic imaging evaluation. Correlate clinically and biochemically.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
